/**
 * @generated SignedSource<<f52c1a91475da2669ab6bd7dc50fb670>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type GrantTerm = "INDEFINITE" | "ONE_MONTH" | "THREE_MONTHS" | "TWELVE_MONTHS" | "%future added value";
export type proGrantMutationsGrantProMutation$variables = {
  reason: string;
  term: GrantTerm;
  vaultId: any;
};
export type proGrantMutationsGrantProMutation$data = {
  readonly grantPro: {
    readonly grantedUntil: any;
    readonly indefinite: boolean;
    readonly vaultId: any;
  };
};
export type proGrantMutationsGrantProMutation = {
  response: proGrantMutationsGrantProMutation$data;
  variables: proGrantMutationsGrantProMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "reason"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "term"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "vaultId"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "reason",
        "variableName": "reason"
      },
      {
        "kind": "Variable",
        "name": "term",
        "variableName": "term"
      },
      {
        "kind": "Variable",
        "name": "vaultId",
        "variableName": "vaultId"
      }
    ],
    "concreteType": "ProGrantState",
    "kind": "LinkedField",
    "name": "grantPro",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "vaultId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "grantedUntil",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "indefinite",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "proGrantMutationsGrantProMutation",
    "selections": (v3/*: any*/),
    "type": "FeatureToggleMutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "proGrantMutationsGrantProMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "2ba245f1eda049fb80d3bcf49b23cff0",
    "id": null,
    "metadata": {},
    "name": "proGrantMutationsGrantProMutation",
    "operationKind": "mutation",
    "text": "mutation proGrantMutationsGrantProMutation(\n  $vaultId: UUID!\n  $term: GrantTerm!\n  $reason: String!\n) {\n  grantPro(vaultId: $vaultId, term: $term, reason: $reason) {\n    vaultId\n    grantedUntil\n    indefinite\n  }\n}\n"
  }
};
})();

(node as any).hash = "44e6813ffb12fd8c6fe789b582676b78";

export default node;
